module.exports = __webpack_public_path__ + "images/records-exist.4f500e27791f2d9fb7a9915caed80269.svg";